<template>
  <modal v-bind="$attrs" v-on="$listeners">
    <div class="">
      <div class="review modal-availability">
        <div class="text-center border-bottom mb-2">
          <img
            src="~rhomtrip_assets/src/img/icons/alerts/success.png"
            alt="question"
            class="icon-modal-alert"
          />
          <h2 class="modal-title">
            Availability Request Submitted Successfully
          </h2>
          <p><strong>Request ID:</strong> {{ quoteNumber }}</p>
        </div>

        <base-alert type="info">
          <h4 class="subtitle mb-1 mt-1">What Happens Next</h4>

          <ol class="number-list">
            <li>
              <span
                >The supplier receives an email to confirm availability.</span
              >
            </li>
            <li>
              <span
                >The customer receives an initial email confirming their request
                is being processed — they are advised to expect a response
                within 12–24 hours.</span
              >
            </li>
            <li>
              <span>
                Monitor the reservation — it will remain pending until the
                supplier responds.
              </span>
            </li>
            <li>
              <span>
                Once the supplier responds, a second email is sent to the
                customer:
              </span>
              <ul>
                <li>
                  <strong>If AVAILABLE:</strong> includes a payment link to
                  complete the booking.
                </li>
                <li>
                  <strong>If UNAVAILABLE:</strong>notifies the customer — no
                  charge is made and no refund is needed.
                </li>
              </ul>
            </li>
          </ol>
        </base-alert>

        <base-alert type="warning" class="mb-0 info-min">
          <i class="flaticon-warning mr-1"></i>
          <strong>Important!</strong>

          You have NOT been charged. No payment is required until availability
          is confirmed.
        </base-alert>
      </div>
    </div>
    <template slot="footer">
      <base-button
        type="outline-neutral"
        class="min-button mb-0"
        @click="handleViewRequest"
        >View Request</base-button
      >

      <base-button
        type="primary"
        class="min-button ml-auto mb-0"
        @click="handleSearchOtherServices"
      >
        New Reservation
      </base-button>
    </template>
  </modal>
</template>

<script>
export default {
  name: "AvailabilityRequestSuccessModal",
  props: {
    quoteNumber: {
      type: String,
      default: ""
    },
    customeEmail: {
      type: String,
      default: ""
    }
  },
  methods: {
    handleViewRequest() {
      this.$emit("viewRequest");
    },
    async handleSearchOtherServices() {
      this.$emit("searchOtherServices");
    }
  }
};
</script>
